import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  HeaderAlertsService,
  IHeaderAlert,
  IHeaderAlertButton,
} from 'src/app/core/services/header-service/header-alerts.service';
import { selectAllHeaderAlerts } from 'src/app/core/store/header-alerts/header-alerts.selectors';

@Component({
  selector: 'app-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertBannerComponent implements OnInit {
  headerAlerts$: Observable<IHeaderAlert[]>;

  constructor(
    private store: Store,
    private headerAlertsSrv: HeaderAlertsService,
  ) {}

  ngOnInit(): void {
    this.headerAlerts$ = this.store.pipe(select(selectAllHeaderAlerts));
  }

  alertButtonClick(alert: IHeaderAlert, button: IHeaderAlertButton): void {
    this.headerAlertsSrv.buttonClick(alert, button);
  }
}
